import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Formik, FieldArray, useField, useFormikContext } from 'formik';
import { Grid, Typography, Box, Button, Slider, TextField as MUITextField, IconButton, DialogActions, DialogTitle, List, ListItem, ListItemText, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { postCommand, useRefresh } from '../../data/fetch';
import { COMMAND } from '../../../common';
import { TextField, ToggleField, Autocomplete, DateField, EnumField } from '../../components/input';

const hasCartonDims = {
  DHL:true,
  DPD:true,
  FedEx:true
}

function CartonDimsField({asset}) {
  const { values } = useFormikContext();
  const cartons = parseInt(values.cartons, 10) || 0;
  console.log("carton asset",asset);
  if (!cartons || !hasCartonDims[asset]) return null;

  return <FieldArray name="carton_dims">{({ form, push, remove }) => {
    const dims = form.values.carton_dims || [];
    while(dims.length < cartons){
      dims.push({});
    }
    while(dims.length > cartons){
      dims.pop();
    }


    return <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Karton</TableCell>
          <TableCell>Szélesség</TableCell>
          <TableCell>Mélység</TableCell>
          <TableCell>Magasság</TableCell>
          <TableCell>Súly</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {dims.map((_, i) => <TableRow key={i}>
          <TableCell>{i + 1}.</TableCell>
          <TableCell><TextField name={`carton_dims.${i}.width`} type="number" margin="none" InputProps={{ endAdornment: 'cm' }} /></TableCell>
          <TableCell><TextField name={`carton_dims.${i}.depth`} type="number" margin="none" InputProps={{ endAdornment: 'cm' }} /></TableCell>
          <TableCell><TextField name={`carton_dims.${i}.height`} type="number" margin="none" InputProps={{ endAdornment: 'cm' }} /></TableCell>
          <TableCell><TextField name={`carton_dims.${i}.weight`} type="number" margin="none" InputProps={{ endAdornment: 'kg' }} /></TableCell>
        </TableRow>)}
      </TableBody>
    </Table>;
  }}</FieldArray>;
}


export default function PrepareDialog(props) {
  let { rec } = props.open;
  let refresh = useRefresh();
  const submit = async (values) => {
    await postCommand('delivery', COMMAND.CHANGE_STATUS, { delivery: rec.id, status: 'READY', values });
    refresh();
    props.close();
  }

  let { cartons, palettes, weight, carton_dims, asset } = rec;

  return <Formik initialValues={{ cartons, palettes, weight, carton_dims: carton_dims || [] }} onSubmit={submit}>{({ handleSubmit, isSubmitting, errors }) => (
    <form onSubmit={handleSubmit} style={{ height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column' }} autocomplete="off">
      <DialogTitle>Csomagok összekészítve</DialogTitle>
      <Grid container sx={{ p: 2 }} columnSpacing={2}>
        <Grid item xs={12} md={3}><TextField name="cartons" type="number" label="Kartonok száma" /></Grid>
        <Grid item xs={12} md={3}><TextField name="weight" label="Súly" InputProps={{ endAdornment: 'kg' }} /></Grid>
        <Grid item xs={12} md={3}><TextField name="carton_size" label="Kartonok mérete" /></Grid>
        <Grid item xs={12} md={3}><TextField name="worker" label="Összekészítő" /></Grid>
        <Grid item xs={12} md={3}><TextField name="palettes" type="number" label="Paletták száma" /></Grid>
        <Grid item xs={12} md={3}><EnumField name="palette_type" label="Paletta típus" options={[
          { value: 'BLUE PALLET', label: 'Kék raklap' },
          { value: 'EUR PALLET', label: 'EUR raklap' },
          { value: 'EW PALLET', label: 'Egyutas raklap' },
          { value: 'HALF PALLET', label: 'Fél raklap' },
        ]} /></Grid>
        <Grid item xs={12} md={3}><TextField name="palette_height" label="Paletták magassága" /></Grid>
      </Grid>
      <Box sx={{ px: 2, maxHeight: 300, overflowY: 'auto' }}>
        <CartonDimsField asset={asset}/>
      </Box>
      <DialogActions>
        <Button sx={{ color: "text.secondary" }} onClick={() => props.cancel()}>Mégsem</Button>
        <Button variant="contained" type="submit" disabled={Object.keys(errors).length !== 0 || isSubmitting}>Összekészítve</Button>
      </DialogActions>
    </form >
  )}
  </Formik>
}